module.exports = __webpack_public_path__ + "static/media/cq_login b.7dd987a8.svg";